<template>
  <div playwright-id="rfp-listing-table">
    <t-datatable
      :hideSearch="true"
      ref="childtable"
      :dataKey="'customerRequests'"
      :actions="{
        get: getRequest,
      }"
      @selectedChanged="selectedChanged"
      :emptyData="{
        show: true,
        imgSrc: $config.noListings,
        message: 'You have no requests listed yet...',
        label: 'Create a request',
        icon: 'pi pi-plus',
        showButton: true,
        function: addNew
      }"
      :config="{
        expand: true,
        addNewSettings: {
          function: addNew,
        },
        expandSettings: {
          onRowExpand: onRowExpand,
          title: 'Quotations',
          key: 'quotations',
          columns: [
            { title: 'Action', custom: viewKit, click: openKit,  },
            { title: 'Thumb', keys: ['thumb_url'], style: 'image' },
            { title: 'id', keys: ['id'] , custom: viewId,},
            // { title: 'title', keys: ['title'] },
            // { title: 'brand', keys: ['brandName'] },
            { title: 'category', keys: ['categoryName'] },
            // { title: 'product', keys: ['productName'] },
            // { title: 'model number', keys: ['modelNumber'] },
            { title: 'condition', keys: ['conditionName'] },
            { title: 'price', keys: ['cprice'] },
            { title: 'currency', keys: ['currencyName'] },
            // { title: 'year', keys: ['itemYear'] },
          ],
        },
        columns: [
          { title: 'ID', keys: ['id'] , custom: viewId, },
          { title: 'Status', keys: ['statusName'],  },
          { title: 'Title', Keys: ['rfp_content', 'title'], custom: title, click: openRfpDetails, },
          { title: 'Budget', keys: ['rfp_content', 'budget'], custom: budgetDisplay,   },
          
          { title: 'Listed since', keys: ['created_at'], custom: timeAgo },
          // { title: 'Deadline', keys: ['dead'], custom: deadlineDisplay },
          {title: 'Views',custom: nbViews, style:'text-align: center',},
          { title: 'Offers', keys: ['offersCount'], custom:offers, click:goToOffers, },
          { title: 'Matches', custom: renderMatchingKits, click:openDialog },
          // {
          //   title: 'View',
          //   click: openRfpDetails,
          //   custom: viewIcon,
          // },
        ],
      }"
    >
    </t-datatable>
  </div>
  <Dialog v-model:visible="dialog_open" :modal="true" position="center" style="width: 90%">
    <template #header>
      Matching Items
    </template>
        <MatchKits :rfpId="rfpId"/>
  </Dialog>
</template>

<script>
// import TDatatable from "../../../../common/components/datatable/TDatatable.vue";
import { defineAsyncComponent } from "vue";
const TDatatable = defineAsyncComponent(() =>
  import("../../../../common/components/datatable/TDatatable.vue")
);
import {
  GET_CUSTOMER_REQUESTS,
  GET_CUSTOMER_RFP_QUOTATIONS,
  GET_OFFERS_kITS
} from "../../store/rfp/actions";
import { OPEN_RFP_DIALOG } from "../../../rfp/store/actions";
import store from "../../../../store";
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import GeneralHelper from "../../../../common/helpers/GeneralHelper";
import QuotationService from '../../../../common/services/rfp/QuotationService';
import Dialog from "primevue/dialog";
import MatchKits from "../../../../common/components/rfp/MatchKits.vue";

export default {
  data() {
    return {
      ReceivedQuotations:[],
      ReceivedQuotation:[],
      dialog_open: false,
      kitId:null
    }
  },

  components: { TDatatable, Dialog, MatchKits },
  methods: {
    selectedChanged(event) {
      this.$emit("selectedChanged", event);
    },
    openDialog(data)
    {
        this.rfpId = data.id
        this.dialog_open = true
    },
    renderMatchingKits(data){
      if (data.status_id !=1 && data.status_id !=3)
        return "<div style='cursor:pointer; padding: 5px; border: 1px solid var(--app-secondary-color); background: transparent; color:var(--app-secondary-color); font-weight:500; font-size:12px; border-radius: 4px; text-align: center;'><span>View Matches</span></div>";
      else return ""
    },
  },

  setup() {
    const router = useRouter();
    const ReceivedQuotations = ref([]);
    const ReceivedQuotation = ref([]);

    let getRequest = GET_CUSTOMER_REQUESTS;

    let onRowExpand = (id) => {
      store.dispatch(GET_CUSTOMER_RFP_QUOTATIONS, id);
    };

    let addNew = () => {
      router.push({name:'Offers', params: {rfpId: data.id}})
    };

    const statusDisplay = (data) => {
      var s = "Under offer";
      if (data.dead < 0) s = "Expired";
      if (data.status_id == 1) s = "Pending";
      if (data.status_id == 4) s = "Completed";
      return s;
    };
    const openRfpDetails = (data) => {
      store.dispatch("toggleRfpDetailsDialog", data).then(() => {
        router.push({name: "rfpDisplayLink", params: {rfpId: data.id}});
      });
    };

    const goToOffers = async(data)=>{ 
      router.push({name:'Offers', params:{rfpId: data.id}})
    }

    const timeAgo = (data) => {
      const givenDate = new Date(data.created_at);
      console.log(givenDate)
      const currentDate = new Date();
      const differenceInMilliseconds = currentDate - givenDate;
      let diffInDays  = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
      
      if (diffInDays === 0) {
        return 'today';
      } else if (diffInDays === 1) {
          return 'yesterday';
      } else if (diffInDays < 30) {
          return `${diffInDays} day${(diffInDays > 1 ? 's ' : ' ')} ago`;
      } else if (diffInDays < 365) {
          const monthsAgo = Math.floor(diffInDays / 30);
          return `${monthsAgo} month${(monthsAgo > 1 ? 's ' : ' ')} ago`;
      } else {
          const yearsAgo = Math.floor(diffInDays / 365);
          return `${yearsAgo} year${(yearsAgo > 1 ? 's ' : ' ')} ago`;
      }
    }

    const offers= (data)=> {
      if(data.offersCount>1)
        return (
            "<span style='cursor:pointer; padding:5px; color:white;  background: var(--app-primary-color); border-radius:25px; font-size:12px; font-weight:500; align-text:center'>"+data.offersCount+" OFFERS</span>"
          );
      else if (data.offersCount==1)
        return (
            "<span style='cursor:pointer; padding:5px; color:white; background: var(--app-primary-color); border-radius:25px; font-size:12px; font-weight:500; align-text:center;'>"+data.offersCount+" OFFER</span>"
          );
      else return "<span></span>";
    };

    const viewId = (data) => {
      return (
        "<span style='cursor:pointer;font-weight:600'>#" + GeneralHelper.pad(data.id, 5) + "</span>"
      );
    };

    const viewKit = () => {
      return "<span style='cursor:pointer; color:blue'>View Item</span>";
    };

    const openKit = (data) => {
      store.dispatch("displayProductDetails1", { option: true, id: data.id });
    };

    const datepostedDisplay = (data) => {
      //return "<span style='width:50px'>"+data.created_at.split("T")[0]+"</span>"
      return data.created_at.split("T")[0];
    };
  

    const deadlineDisplay = (data) => {
      return data.dead + " days";
    };
    const offerRangeDisplay = (data) => {
      var min = data.minOffer == null ? "" : data.minOffer;
      var max = data.maxOffer == null ? "" : data.maxOffer;

      return store.getters.symbol + " " + min + "-" + store.getters.symbol + " " + max;
    };

 
    const budgetDisplay = (data) => {
      if (!data.rfp_content.budget[1]) return "Not Specified";
      if (data.rfp_content.budget.length == 0) return "-";
      return (
        // data.rfp_content.currency.symbo +
        // data.rfp_content.budget[0] +
        // " - " +
        data.rfp_content.currency.symbo + data.rfp_content.budget[1]
      );
    };
    const title = (data) => {
      let result = "<span style='cursor:pointer;text-decoration:underline; font-weight:600'>"+ data.rfp_content.title +"</span>";
      return result;
    };

  
    const nbViews = (data) => {
      return data.views;
    }
    const childtable = ref(null);
    const unselectData = () => {
      childtable.value.unselectSelectedData();
    };
    return {
      unselectData,
      childtable,
      getRequest,
      datepostedDisplay,
      deadlineDisplay,
      offerRangeDisplay,
      budgetDisplay,
      statusDisplay,
      onRowExpand,
      openRfpDetails,
      openKit,
      addNew,
      viewKit,
      title,
      timeAgo,
      viewId,
      nbViews,
      offers,
      goToOffers,
    };
  },
};
</script>

<style></style>
